import { useNavigate } from "react-router-dom";
import { useProjects } from "../modules/common/contexts/ProjectContext";
import { slugify } from "../utils/slugify";

/**
 * Hook that provides project-aware navigation.
 * Prepends the active project slug to module paths.
 *
 * Usage:
 *   const { projectPath, navigate } = useProjectNavigation();
 *   navigate(projectPath('/logger'));   // → /my-project/logger
 *   navigate('/');                      // → / (home, no prefix)
 */
export function useProjectNavigation() {
  const navigate = useNavigate();
  const { activeProject } = useProjects();

  const projectPath = (path: string): string => {
    if (!activeProject || path === "/") return path;
    const slug = slugify(activeProject.name);
    return `/${slug}${path}`;
  };

  return { navigate, projectPath };
}
